import { render, staticRenderFns } from "./Vorzugswert.vue?vue&type=template&id=c9f51836&"
import script from "./Vorzugswert.vue?vue&type=script&lang=js&"
export * from "./Vorzugswert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports